<script lang="ts">
    import SigninPage from '~/pages/signin/index.vue';

    export default SigninPage;
</script>
